<template lang="pug">
    .preloader
        .preloader__line(:class="{'preloader__line--start': preloaderStart && !preloaderHide, 'preloader__line--end': preloaderEnd && !preloaderHide}")
</template>

<script>

    import EventBus from '@/eventBus';

    export default {
        name: 'Preloader',

        components: {

        },

        data() {
            return {
                preloaderStart: false,
                preloaderEnd: false,
                preloaderHide: false
            }
        },

        created() {
            EventBus.$on('preloaderShow', () => {
                this.preloaderStart = true;
                this.preloaderHide = false;
            });

            EventBus.$on('preloaderHide', () => {
                this.preloaderEnd = true;

                this.$nextTick(() => {
                    let $menuTopItems = $('.menu-top__item');

                    $menuTopItems.removeClass('menu-top__item--active');
                    $menuTopItems.filter('.router-link-exact-active').addClass('menu-top__item--active');

                    // let $hiddenMenuItems = $('.hidden-menu__nav-item');
                    // $hiddenMenuItems.removeClass('hidden-menu__nav-item--active');
                    // $hiddenMenuItems.filter('.router-link-exact-active').addClass('hidden-menu__nav-item--active');
                    $('.hidden-menu__nav-item').filter('.router-link-exact-active').addClass('hidden-menu__nav-item--active');
                    EventBus.$emit('menuHide');
                });
            });
        },

        mounted() {
            $('.preloader__line').on('transitionend', () => {
                this.preloaderHide = true;
            })
        }
    }
</script>
